import React from 'react'
import Routing from './config/routing'

function App() {
    return <Routing />
}

export default App
